'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectHighlighted = exports.selectColor = exports.selectWeight = exports.selectType = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  font-family: ', ';\n  color: ', ';\n  line-height: 1.23;\n'], ['\n  font-family: ', ';\n  color: ', ';\n  line-height: 1.23;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n          font-family: ', ';\n          font-size: 20px;\n          line-height: 1.4;\n        '], ['\n          font-family: ', ';\n          font-size: 20px;\n          line-height: 1.4;\n        ']),
    _templateObject3 = _taggedTemplateLiteral(['\n          font-family: ', ';\n          font-size: 16px;\n          line-height: 1.5;\n        '], ['\n          font-family: ', ';\n          font-size: 16px;\n          line-height: 1.5;\n        ']),
    _templateObject4 = _taggedTemplateLiteral(['\n          font-family: ', ';\n          font-size: 14px;\n          line-height: 1.57;\n        '], ['\n          font-family: ', ';\n          font-size: 14px;\n          line-height: 1.57;\n        ']),
    _templateObject5 = _taggedTemplateLiteral(['\n          font-family: ', ';\n          font-size: 12px;\n          line-height: 1.5;\n        '], ['\n          font-family: ', ';\n          font-size: 12px;\n          line-height: 1.5;\n        ']),
    _templateObject6 = _taggedTemplateLiteral(['\n          font-weight: bold;\n        '], ['\n          font-weight: bold;\n        ']),
    _templateObject7 = _taggedTemplateLiteral(['\n          font-weight: normal;\n        '], ['\n          font-weight: normal;\n        ']),
    _templateObject8 = _taggedTemplateLiteral(['\n    font-weight: normal;\n  '], ['\n    font-weight: normal;\n  ']),
    _templateObject9 = _taggedTemplateLiteral(['\n          color: ', ';\n        '], ['\n          color: ', ';\n        ']),
    _templateObject10 = _taggedTemplateLiteral(['\n    color: ', ';\n  '], ['\n    color: ', ';\n  ']),
    _templateObject11 = _taggedTemplateLiteral(['\n    background-color: ', ';\n    box-shadow: 0 0 0 0.2em ', ';\n  '], ['\n    background-color: ', ';\n    box-shadow: 0 0 0 0.2em ', ';\n  ']),
    _templateObject12 = _taggedTemplateLiteral(['\n    font-style: italic;\n  '], ['\n    font-style: italic;\n  ']),
    _templateObject13 = _taggedTemplateLiteral(['\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n  '], ['\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n  ']);

var _reactEmotion = require('@quid-private/react-emotion');

var _light = require('./themes/light');

var _light2 = _interopRequireDefault(_light);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var primaryFontFamily = ['IBM Plex Sans', 'Lucida Grande', 'Tahoma', 'Verdana', 'Arial', 'sans-serif'].join(', ');
var secondaryFontFamily = ['IBM Plex Serif', 'Gudea', 'Lucida Grande', 'Tahoma', 'Verdana', 'Arial', 'sans-serif'].join(', ');

var baseStyle = function baseStyle(theme) {
  return (0, _reactEmotion.css)(_templateObject, primaryFontFamily, theme.primary);
};

var selectType = exports.selectType = function selectType(type, theme) {
  if (typeof type === 'string') {
    switch (type) {
      case 'xlarge':
        return (0, _reactEmotion.css)(_templateObject2, primaryFontFamily);

      case 'large':
        return (0, _reactEmotion.css)(_templateObject3, primaryFontFamily);

      case 'normal':
        return (0, _reactEmotion.css)(_templateObject4, primaryFontFamily);

      case 'title':
        return (0, _reactEmotion.css)(_templateObject3, secondaryFontFamily);

      case 'body':
        return (0, _reactEmotion.css)(_templateObject4, secondaryFontFamily);

      case 'caption':
        return (0, _reactEmotion.css)(_templateObject5, primaryFontFamily);
    }
  }

  return baseStyle(theme);
};

var selectWeight = exports.selectWeight = function selectWeight(weight) {
  if (typeof weight === 'string') {
    switch (weight) {
      case 'bold':
        return (0, _reactEmotion.css)(_templateObject6);

      case 'regular':
        return (0, _reactEmotion.css)(_templateObject7);
    }
  }

  return (0, _reactEmotion.css)(_templateObject8);
};

var selectColor = exports.selectColor = function selectColor(color, _ref) {
  var primary = _ref.primary,
      secondary = _ref.secondary,
      disabled = _ref.disabled,
      link = _ref.link;

  if (typeof color === 'string') {
    switch (color) {
      case 'secondary':
        return (0, _reactEmotion.css)(_templateObject9, secondary);

      case 'disabled':
        return (0, _reactEmotion.css)(_templateObject9, disabled);

      case 'link':
        return (0, _reactEmotion.css)(_templateObject9, link);
    }
  }

  return (0, _reactEmotion.css)(_templateObject10, primary);
};

var selectHighlighted = exports.selectHighlighted = function selectHighlighted(highlighted, theme) {
  return highlighted && (0, _reactEmotion.css)(_templateObject11, theme.highlighted, theme.highlighted);
};

var selectItalic = function selectItalic(italic) {
  return italic && (0, _reactEmotion.css)(_templateObject12);
};

var isType = function isType(a) {
  return ['xlarge', 'large', 'normal', 'title', 'body', 'caption'].includes(a);
};

var isWeight = function isWeight(a) {
  return ['bold', 'regular'].includes(a);
};

var isColor = function isColor(a) {
  return ['secondary', 'disabled', 'link'].includes(a);
};

var isHighlighted = function isHighlighted(a) {
  return ['highlighted'].includes(a);
};

var isItalic = function isItalic(a) {
  return ['italic'].includes(a);
};

var getAttribute = function getAttribute(array) {
  return array.filter(function (x) {
    return x !== undefined;
  }).reduce(function (acc, current) {
    return {
      type: isType(current) ? current : acc.type,
      color: isColor(current) ? current : acc.color,
      weight: isWeight(current) ? current : acc.weight,
      highlighted: isHighlighted(current) ? true : acc.highlighted,
      italic: isItalic(current) ? true : acc.italic
    };
  }, {
    type: '',
    color: '',
    weight: '',
    highlighted: false,
    italic: false
  });
};

var textStyles = function textStyles() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _light2.default;

  var _getAttribute = getAttribute(options),
      type = _getAttribute.type,
      color = _getAttribute.color,
      weight = _getAttribute.weight,
      highlighted = _getAttribute.highlighted,
      italic = _getAttribute.italic;

  return (0, _reactEmotion.css)(_templateObject13, selectType(type, theme), selectWeight(weight, theme), selectColor(color, theme), selectHighlighted(highlighted, theme), selectItalic(italic, theme));
};

exports.default = textStyles;